import { faAngleRight } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";
import LinkButton from "common/components/LinkButton";

import { urls } from "client/routes";

import styles from "../styles/DealsMarketingBanner.module.less";

const DealsMarketingBanner = () => {
  return (
    <LinkButton className={styles.banner} dest={urls.products.deals()}>
      <span className={styles.message}>
        Shop top deals — limited-time offers and autoship discounts, all in one place
      </span>
      <span className={styles.shopButton}>
        Shop deals <Icon icon={faAngleRight} />
      </span>
    </LinkButton>
  );
};

export default DealsMarketingBanner;
